






import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class SimpleAlert extends Vue {
  @Prop({ required: true }) message!: string;

  @Prop({ required: true }) timeout!: number;

  mounted() {
    setTimeout(() => {
      console.log(this.message);
    }, this.timeout);
  }
}
